export const MOCK_INVITE_A_ID = 'MOCK_INVITE_A_ID'
